import api from "@/config/apiConfig"

class AuthController {

  async login(req) {
    try {
      const response = await api.post("/auth/login", req);
      return response.data;
    } catch (error) {
      console.error("Erro no AuthController.login: ", error);
      throw error;
    }
  }

  async register(req) {
    try {
      const response = await api.post("/auth/register", req);
      return response.data;
    } catch (error) {
      console.error("Erro no AuthController.register: ", error);
      throw error;
    }
  }
  async impersonate(companyId) {
    try {
      const response = await api.post(`/auth/impersonate/${companyId}`);
      return response.data;
    } catch (error) {
      console.error("Erro no AuthController.impersonate: ", error);
      throw error;
    }
  }

  async getMenus() {
    try {
      const response = await api.get("/auth/menus");
      return response.data;
    } catch (error) {
      console.error("Erro no AuthController.getMenus: ", error);
      throw error;
    }
  }

}

export default new AuthController();